// Collection slider for sections/pg-hero.liquid: swipe (native scroll-snap), dots, optional autoplay.
if (!customElements.get('pg-hero-slider')) {
  customElements.define(
    'pg-hero-slider',
    class PgHeroSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        if (!this.track || this.slides.length < 2) return;

        this.dots.forEach((dot) =>
          dot.addEventListener('click', () => {
            this.goTo(Number(dot.dataset.dot));
            this.restart();
          })
        );

        this.onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduceMotion;
        this.speed = Number(this.dataset.speed) || 5000;

        // Pause while the shopper is interacting or the slider is off screen
        ['mouseenter', 'focusin', 'touchstart'].forEach((e) => this.addEventListener(e, () => this.stop(), { passive: true }));
        ['mouseleave', 'focusout', 'touchend'].forEach((e) => this.addEventListener(e, () => this.restart(), { passive: true }));
        this.observer = new IntersectionObserver(([entry]) => (entry.isIntersecting ? this.restart() : this.stop()));
        this.observer.observe(this);

        // Theme editor: jump to the block being edited
        this.addEventListener('shopify:block:select', (event) => {
          const i = this.slides.indexOf(event.target);
          if (i > -1) this.goTo(i, false);
          this.stop();
        });
      }

      disconnectedCallback() {
        this.stop();
        if (this.observer) this.observer.disconnect();
      }

      goTo(i, smooth = true) {
        const count = this.slides.length;
        this.index = (i + count) % count;
        this.track.scrollTo({ left: this.slides[this.index].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
        this.update();
      }

      onScroll() {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (i !== this.index) {
            this.index = i;
            this.update();
          }
        }, 60);
      }

      update() {
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.setAttribute('aria-hidden', String(!active));
          slide.querySelectorAll('a').forEach((a) => {
            if (a.classList.contains('pg-hero__slide-media')) return;
            if (active) a.removeAttribute('tabindex');
            else a.setAttribute('tabindex', '-1');
          });
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-selected', String(i === this.index)));
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        if (!this.autoplay) return;
        this.timer = setInterval(() => this.goTo(this.index + 1), this.speed);
      }
    }
  );
}
